import { axiosInstance as request } from '@api/rest.service'

/* PROVIDERS */

/**
 * @typedef ProviderResponse
 * @property {number} id
 * @property {string} name
 */

/**
 * @description GET /providers
 * @returns {AxiosPromise<{result: ProviderResponse[]}>}
 */
export const PROVIDERS = () => request.get('/providers')

/* IMPORT PROVIDERS */
const api = '/imports/providers'

/**
 * @description GET /imports/providers
 * @returns {AxiosPromise<any>}
 */
export const GET_PROVIDERS_IMPORTS = () => request.get(api)

/**
 * @description GET /imports/providers/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_PROVIDERS_IMPORT = id => request.get(`${api}/${id}`)

/**
 * @description GET /imports/providers/template
 * @returns {AxiosPromise<any>}
 */
export const GET_PROVIDERS_IMPORT_TEMPLATE = () => request.get(`${api}/template`)

/**
 * @description POST /imports/providers/parse
 * @returns {AxiosPromise<any>}
 */
export const PARSE_PROVIDERS_IMPORT = payload => request.post(`${api}/parse`, payload)

/**
 * @description PUT /imports/providers/preview/rows/{rowId}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_PROVIDERS_IMPORT_ROWS = (rowId, payload) => request.put(`${api}/preview/rows/${rowId}`, payload)

/**
 * @description POST /imports/providers/process
 * @returns {AxiosPromise<any>}
 */
export const PROCESS_PROVIDERS_IMPORT = payload => request.post(`${api}/process`, payload)
